<h2>VIP Бонусы</h2>

<div class="container vip-content">
  <div class="progress-bar" *ngIf="isDashboardLoading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>

  <div *ngIf="dashboardError && !isDashboardLoading" class="error-message">
    <mat-icon>error_outline</mat-icon>
    <span>{{ dashboardError }}</span>
  </div>

  <ng-container *ngIf="dashboard && !isDashboardLoading">
    <div *ngIf="isExcluded" class="excluded-warning">
      <mat-icon color="warn">warning</mat-icon>
      <span>Исключён из VIP: {{ exclusionReason }}</span>
    </div>

    <section class="section">
      <h3>Сводка</h3>
      <div class="summary-grid">
        <mat-card *ngFor="let card of summaryCards" class="summary-card">
          <div class="summary-card__title">{{ card.title }}</div>
          <div class="summary-card__value">{{ card.value }}</div>
          <div class="summary-card__hint">{{ card.hint }}</div>
        </mat-card>
      </div>
    </section>

    <section class="section detail-grid">
      <mat-card class="detail-card">
        <mat-card-header>
          <mat-card-title>Статус и XP</mat-card-title>
          <mat-card-subtitle>Базовые VIP показатели пользователя</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="detail-list">
            <div class="detail-row">
              <span>Тир</span>
              <strong>{{ tierName | titlecase }}</strong>
            </div>
            <div class="detail-row">
              <span>Уровень</span>
              <strong>{{ level }} / 30</strong>
            </div>
            <div class="detail-row">
              <span>Всего XP</span>
              <strong>{{ totalXp }}</strong>
            </div>
            <div class="detail-row">
              <span>K-коэфф.</span>
              <strong>{{ kCoefficient }}</strong>
            </div>
            <div class="detail-row">
              <span>XP множитель</span>
              <strong>{{ multiplier }}</strong>
            </div>
            <div class="detail-row">
              <span>До следующего уровня</span>
              <strong>{{ xpToNextLevel }}</strong>
            </div>
          </div>

          <div class="xp-progress-section">
            <span>До уровня {{ level + 1 }}: {{ xpToNextLevelLabel }}</span>
            <span class="section-hint">Точный процент прогресса уровня не приходит в текущем dashboard API.</span>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="detail-card">
        <mat-card-header>
          <mat-card-title>Бонусы и стрик</mat-card-title>
          <mat-card-subtitle>Текущие усилители и награды</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="detail-list">
            <div class="detail-row">
              <span>Текущий стрик</span>
              <strong>{{ streakDays }} дн.</strong>
            </div>
            <div class="detail-row">
              <span>Бонус за стрик</span>
              <strong>{{ streakBonus }}</strong>
            </div>
            <div class="detail-row">
              <span>Каскад готов к выдаче</span>
              <strong>{{ availableCascadeBonuses }}</strong>
            </div>
            <div class="detail-row">
              <span>Награды доступны</span>
              <strong>{{ claimableRewards }}</strong>
            </div>
          </div>

          <div class="bonus-detail-list">
            <div *ngFor="let detail of bonusDetails" class="bonus-detail-row">
              <div class="bonus-detail-row__title">{{ detail.title }}</div>
              <div class="bonus-detail-row__description">{{ detail.description }}</div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </section>

    <section class="section">
      <h3>Квесты</h3>
      <mat-card class="quest-card">
        <mat-card-content *ngIf="questGames.length > 0; else noQuestGames">
          <div class="quest-toolbar">
            <mat-button-toggle-group
              [value]="selectedGameSlug"
              (change)="selectGame($event.value)"
              aria-label="Quest game switcher">
              <mat-button-toggle *ngFor="let game of questGames" [value]="game.gameSlug">
                {{ game.gameLabel }}
              </mat-button-toggle>
            </mat-button-toggle-group>

            <div class="quest-toolbar__summary" *ngIf="selectedGame">
              <div>{{ selectedGame.gameLabel }}</div>
              <div class="section-hint">
                Забрано: {{ selectedGame.claimedCount }} / 10, не забрано: {{ selectedGame.readyToClaimCount }},
                {{ selectedGame.currentQuestLabel }}
              </div>
            </div>
          </div>

          <div class="quest-board" *ngIf="selectedGame">
            <button
              type="button"
              class="quest-strip"
              *ngFor="let quest of selectedGame.quests"
              [class.quest-strip--selected]="isQuestSelected(quest)"
              [class.quest-strip--claimed]="quest.status === 'claimed'"
              [class.quest-strip--ready]="quest.status === 'completed-awaiting-claim'"
              [class.quest-strip--active]="quest.status === 'in-progress'"
              [class.quest-strip--locked]="quest.status === 'locked'"
              (click)="selectQuest(quest)">
              <span class="quest-strip__header">
                <span class="quest-strip__label">Стадия {{ quest.questNumber }}</span>
                <span class="quest-strip__progress">{{ quest.progressLabel }}</span>
              </span>
              <span class="quest-strip__bar">
                <span class="quest-strip__fill" [style.width.%]="quest.progressPercent"></span>
              </span>
              <span class="quest-strip__status">{{ quest.statusLabel }}</span>
            </button>
          </div>

          <div class="quest-legend">
            <div class="quest-legend__item">
              <span class="quest-legend__swatch quest-legend__swatch--claimed"></span>
              <span>Квест забран</span>
            </div>
            <div class="quest-legend__item">
              <span class="quest-legend__swatch quest-legend__swatch--ready"></span>
              <span>Квест не забран</span>
            </div>
            <div class="quest-legend__item">
              <span class="quest-legend__swatch quest-legend__swatch--active"></span>
              <span>В процессе</span>
            </div>
            <div class="quest-legend__item">
              <span class="quest-legend__swatch quest-legend__swatch--locked"></span>
              <span>Закрыт</span>
            </div>
          </div>

          <div class="quest-selection" *ngIf="selectedGame && selectedQuest">
            <div class="quest-selection__title">
              {{ selectedGame.gameLabel }} / стадия {{ selectedQuest.questNumber }}
            </div>
            <div class="section-hint">
              Статус: {{ selectedQuest.statusLabel }}, прогресс: {{ selectedQuest.progressLabel }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>

      <mat-card class="log-card">
        <mat-card-header>
          <mat-card-title>Лог XP по квесту</mat-card-title>
          <mat-card-subtitle>Постраничная загрузка только для выбранного квеста</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="progress-bar progress-bar--section" *ngIf="isQuestLogLoading">
            <mat-progress-bar mode="indeterminate"></mat-progress-bar>
          </div>

          <div *ngIf="questLogError" class="error-message error-message--inline">
            <mat-icon>error_outline</mat-icon>
            <span>{{ questLogError }}</span>
          </div>

          <div *ngIf="selectedQuest; else selectQuestHint" class="log-table-container">
            <mat-table [dataSource]="questLogItems" class="table mat-elevation-z1">
              <ng-container matColumnDef="time">
                <mat-header-cell *matHeaderCellDef>Время</mat-header-cell>
                <mat-cell *matCellDef="let item">
                  {{ formatLogTime(item) ? (formatLogTime(item) | date: 'dd.MM.yyyy HH:mm') : '—' }}
                </mat-cell>
              </ng-container>

              <ng-container matColumnDef="wagerAmount">
                <mat-header-cell *matHeaderCellDef>Ставка</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ formatLogWager(item) }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="xpContributed">
                <mat-header-cell *matHeaderCellDef>XP</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ formatLogXp(item) }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="progress">
                <mat-header-cell *matHeaderCellDef>Прогресс</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ formatLogProgress(item) }}</mat-cell>
              </ng-container>

              <ng-container matColumnDef="status">
                <mat-header-cell *matHeaderCellDef>Статус / результат</mat-header-cell>
                <mat-cell *matCellDef="let item">{{ formatLogStatus(item) }}</mat-cell>
              </ng-container>

              <mat-header-row *matHeaderRowDef="questLogColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: questLogColumns;"></mat-row>

              <div class="empty-data" *matNoDataRow>
                <p>{{ isQuestLogLoading ? 'Загрузка логов...' : 'По выбранному квесту записей нет' }}</p>
              </div>
            </mat-table>

            <mat-paginator
              [length]="questLogTotalRows"
              [pageIndex]="questLogPageIndex"
              [pageSize]="questLogPageSize"
              [pageSizeOptions]="questPageSizeOptions"
              (page)="pageChanged($event)"
              aria-label="Quest log pagination">
            </mat-paginator>
          </div>
        </mat-card-content>
      </mat-card>
    </section>

    <section class="section secondary-grid">
      <div *ngIf="cascadeSlots.length > 0">
        <h3>Каскадные слоты</h3>
        <mat-table [dataSource]="cascadeSlots" class="table mat-elevation-z1">
          <ng-container matColumnDef="slotType">
            <mat-header-cell *matHeaderCellDef>Тип</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.slotType | titlecase }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="bonusCount">
            <mat-header-cell *matHeaderCellDef>Прогресс</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.bonusCount }} / {{ item.maxBonuses }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="isClaimed">
            <mat-header-cell *matHeaderCellDef>Статус</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.isClaimed ? 'Получен' : 'Доступен' }}</mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="cascadeColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: cascadeColumns;"></mat-row>
        </mat-table>
      </div>

      <div *ngIf="caseData.length > 0">
        <h3>Кейсы</h3>
        <mat-table [dataSource]="caseData" class="table mat-elevation-z1">
          <ng-container matColumnDef="period">
            <mat-header-cell *matHeaderCellDef>Период</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.period | titlecase }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="currentStage">
            <mat-header-cell *matHeaderCellDef>Стадия</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.currentStage }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="valueLabel">
            <mat-header-cell *matHeaderCellDef>Стоимость</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.valueLabel }}</mat-cell>
          </ng-container>

          <ng-container matColumnDef="claimStatus">
            <mat-header-cell *matHeaderCellDef>Статус</mat-header-cell>
            <mat-cell *matCellDef="let item">{{ item.claimStatus }}</mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="caseColumns"></mat-header-row>
          <mat-row *matRowDef="let row; columns: caseColumns;"></mat-row>
        </mat-table>
      </div>
    </section>

    <section class="section" *ngIf="levelRewards.length > 0">
      <h3>Награды за уровни</h3>
      <mat-table [dataSource]="levelRewards" class="table mat-elevation-z1">
        <ng-container matColumnDef="level">
          <mat-header-cell *matHeaderCellDef>Уровень</mat-header-cell>
          <mat-cell *matCellDef="let reward">{{ reward.level }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="reward">
          <mat-header-cell *matHeaderCellDef>Награда</mat-header-cell>
          <mat-cell *matCellDef="let reward">{{ formatReward(reward) }}</mat-cell>
        </ng-container>

        <ng-container matColumnDef="claimed">
          <mat-header-cell *matHeaderCellDef>Статус</mat-header-cell>
          <mat-cell *matCellDef="let reward">{{ formatRewardStatus(reward) }}</mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="rewardColumns"></mat-header-row>
        <mat-row *matRowDef="let row; columns: rewardColumns;"></mat-row>
      </mat-table>
    </section>

    <div class="api-limit-note">
      <mat-icon>info_outline</mat-icon>
      <div>
        <div class="api-limit-note__title">Примечания по данным</div>
        <ul>
          <li *ngFor="let note of apiLimitNotes">{{ note }}</li>
        </ul>
      </div>
    </div>
  </ng-container>
</div>

<ng-template #noQuestGames>
  <div class="empty-state">
    <mat-icon>flag</mat-icon>
    <span>Dashboard не вернул квестовые игры для этого пользователя.</span>
  </div>
</ng-template>

<ng-template #selectQuestHint>
  <div class="empty-state">
    <mat-icon>touch_app</mat-icon>
    <span>Выберите квест, чтобы загрузить его XP лог.</span>
  </div>
</ng-template>
